<!-- Ported from the Polaris kit: src/components/ui/alert/AlertDescription.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="alert-description"
    :class="
      cn(
        'text-polaris-muted-foreground col-start-2 type-polaris-body [&_p]:leading-relaxed',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
